"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterDocumentsByType = filterDocumentsByType;
exports.filterDocumentsByStatus = filterDocumentsByStatus;
exports.filterDocumentsByTitle = filterDocumentsByTitle;
/**
 * Filters an array of documents by their type.
 *
 * @param docs - The array of documents to filter.
 * @param types - The allowed document types ('idea', 'design', 'plan', 'ctx').
 * @returns A new array containing only documents with a type in the given list.
 */
function filterDocumentsByType(docs, types) {
    return docs.filter(d => types.includes(d.type));
}
/**
 * Filters an array of documents by their status.
 *
 * @param docs - The array of documents to filter.
 * @param statuses - The allowed status values.
 * @returns A new array containing only documents with a status in the given list.
 */
function filterDocumentsByStatus(docs, statuses) {
    return docs.filter(d => statuses.includes(d.status));
}
/**
 * Filters an array of documents by a pattern matched against their title.
 *
 * @param docs - The array of documents to filter.
 * @param pattern - A case‑insensitive substring or regular expression.
 * @returns A new array containing only documents whose title matches the pattern.
 */
function filterDocumentsByTitle(docs, pattern) {
    const regex = new RegExp(pattern, 'i');
    return docs.filter(d => regex.test(d.title));
}
